import { AccessGate } from '../../shared/access/AccessControls';
import { useAllowedMutation, withAccess } from '../../shared/access/AccessControls';
import React, { useEffect } from 'react';
import {
  Button,
  Flex,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  useDisclosure,
  Grid,
} from '@chakra-ui/react';
import { SubmitHandler, useForm } from 'react-hook-form';
import FormInput from '../../shared/components/FormInput';
import FormSelect from '../../shared/components/FormSelect';
import { mediaLibraryTagsApi } from '../../store/services/MediaLibraryTagsService';
import { UpdateMLTagByIdRequest } from '../../store/responseTypes/mediaLibraryTags';
import { MLTagType } from '../../shared/types/mediaLibraryTag';

type IPlanModal = {
  activator: React.ReactNode;
};

const AddTagModal = ({ activator }: IPlanModal) => {
  const { isOpen, onOpen, onClose } = useDisclosure();

  const [createTag, { isLoading: isCreating, isSuccess: isCreated }] =
    useAllowedMutation(mediaLibraryTagsApi.useCreateMlTagMutation, 'createMlTag');

  const { register, reset, handleSubmit } = useForm<UpdateMLTagByIdRequest>();

  useEffect(() => {
    if (isOpen) reset({});
  }, [isOpen]);

  const onSubmit: SubmitHandler<UpdateMLTagByIdRequest> = (args) => {
    const formType = args.type.toString();
    createTag({
      ...args,
      type: parseInt(formType),
      isCategory: false,
    });
  };

  useEffect(() => {
    if (isCreated) onClose();
  }, [isCreated]);

  return (
    <>
      <div role={'button'} onClick={onOpen}>
        {activator}
      </div>

      <Modal size={'xl'} {...{ onClose, isOpen }}>
        <ModalOverlay />
        <ModalContent mx={'1rem'}>
          <form onSubmit={handleSubmit(onSubmit)}>
            <ModalHeader>Adding tag</ModalHeader>
            <ModalBody>
              <Grid rowGap={'1rem'} gridTemplateColumns={'1fr'}>
                <FormInput
                  name={'label'}
                  ph={'Label i18 (optional)'}
                  register={register}
                />
                <FormInput name={'value'} ph={'Value'} register={register} />
                <FormSelect
                  register={register}
                  ph={'Type'}
                  name={'type'}
                  labeledOptions={[
                    {
                      label: 'Tag',
                      value: MLTagType.TAG,
                    },
                    {
                      label: 'Color',
                      value: MLTagType.COLOR,
                    },
                  ]}
                />
              </Grid>
            </ModalBody>
            <ModalFooter>
              <Flex gridGap={'0.5rem'} justifyContent={'flex-end'}>
                <Button type={'button'} onClick={onClose}>
                  Cancel
                </Button>
                <AccessGate action="legacyFilerAdminOnly"><Button
                  colorScheme={'blue'}
                  type={'submit'}
                  isLoading={isCreating}
                >
                  Save
                </Button></AccessGate>
              </Flex>
            </ModalFooter>
          </form>
        </ModalContent>
      </Modal>
    </>
  );
};

export default withAccess(AddTagModal, 'legacyFilerAdminOnly');
